export const UserType = {
  New: 'pending',
  Existing: 'approved',
  All: ''
}
